import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit', month: 'long', year: 'numeric'
  }).format(date);
}

export function formatDateShort(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit', month: '2-digit', year: 'numeric'
  }).format(date);
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency', currency: 'EUR'
  }).format(amount || 0);
}

export function formatInvoiceStatus(status) {
  const labels = {
    'brouillon': 'Brouillon',
    'en_validation': 'En validation',
    'validee': 'Validée',
    'rejetee': 'Rejetée',
    'modification_demandee': 'Modification demandée',
    'payee': 'Payée',
    'annulee': 'Annulée'
  };
  return labels[status] || status;
}

export function getInvoiceStatusColor(status) {
  const colors = {
    'brouillon': 'bg-slate-100 text-slate-700',
    'en_validation': 'bg-blue-100 text-blue-700',
    'validee': 'bg-green-100 text-green-700',
    'rejetee': 'bg-red-100 text-red-700',
    'modification_demandee': 'bg-orange-100 text-orange-700',
    'payee': 'bg-emerald-100 text-emerald-700',
    'annulee': 'bg-gray-100 text-gray-500'
  };
  return colors[status] || 'bg-slate-100 text-slate-700';
}

export function formatPaymentStatus(status) {
  const labels = {
    'non_payee': 'Non payée',
    'partiellement_payee': 'Partiellement payée',
    'payee': 'Payée'
  };
  return labels[status] || status;
}

export function getPaymentStatusColor(status) {
  const colors = {
    'non_payee': 'bg-red-100 text-red-700',
    'partiellement_payee': 'bg-amber-100 text-amber-700',
    'payee': 'bg-green-100 text-green-700'
  };
  return colors[status] || 'bg-slate-100 text-slate-700';
}

export function getStatusColor(status) {
  const colors = {
    'en_attente': 'status-pending',
    'approuve': 'status-approved',
    'refuse': 'status-rejected',
    'actif': 'status-active',
    'inactif': 'status-inactive',
  };
  return colors[status] || 'status-pending';
}

export function getStatusLabel(status) {
  const labels = {
    'en_attente': 'En attente',
    'approuve': 'Approuve',
    'refuse': 'Refuse',
    'actif': 'Actif',
    'inactif': 'Inactif',
  };
  return labels[status] || status;
}

// ==================== E-Invoicing — Réforme sept. 2026 ====================

export const STATUT_FISCAL_LABELS = {
  deposee: 'Déposée',
  rejetee: 'Rejetée',
  refusee: 'Refusée',
  encaissee: 'Encaissée',
  mise_a_disposition: 'Mise à disposition',
  prise_en_charge: 'Prise en charge',
  approuvee: 'Approuvée',
  approuvee_partiellement: 'Approuvée part.',
  paiement_transmis: 'Paiement transmis',
  suspendue: 'Suspendue',
  complement_demande: 'Complément demandé',
};

export const STATUT_FISCAL_COLORS = {
  deposee: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  rejetee: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
  refusee: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
  encaissee: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
  mise_a_disposition: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300',
  prise_en_charge: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300',
  approuvee: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
  approuvee_partiellement: 'bg-lime-100 text-lime-700 dark:bg-lime-900/30 dark:text-lime-300',
  paiement_transmis: 'bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-300',
  suspendue: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  complement_demande: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300',
};

export const NATURE_OPERATION_LABELS = {
  livraison_biens: 'Livraison de biens',
  prestation_services: 'Prestation de services',
  mixte: 'Opération mixte',
};

export const CATEGORIE_TVA_LABELS = {
  S: 'Standard (20%)',
  AA: 'Réduit (5,5%)',
  E: 'Exonérée',
  AE: 'Autoliquidation',
  K: 'Intracommunautaire',
  G: 'Export hors UE',
  O: 'Hors champ TVA',
  Z: 'Taux zéro',
};

export const FORMAT_EINVOICE_LABELS = {
  'factur-x': 'Factur-X',
  ubl: 'UBL 2.1',
  cii: 'CII',
};

export function formatStatutFiscal(statut) {
  return STATUT_FISCAL_LABELS[statut] || statut || '';
}

export function getStatutFiscalColor(statut) {
  return STATUT_FISCAL_COLORS[statut] || 'bg-slate-100 text-slate-600';
}
